// Main Components
import * as React from "react"
import { StaticImage } from "gatsby-plugin-image";

const BackgroundImage = () => {
  return(
      <StaticImage
      src="../images/background.png"
      quality={100}
      alt=""
      style={{
      position: "absolute", 
      width: "100%", 
      height: "100%", 
      zIndex: "-10",
      }}
      />
  )
}

export default BackgroundImage;
